module.exports = __webpack_public_path__ + "img/circle-exclamation-sharp-light.75fca0fe.svg";